import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container py-5" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-12 mb-10" }
const _hoisted_4 = { class: "card mb-25 border-0 rounded-0" }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_6 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 mb-20" }
const _hoisted_7 = { class: "position-relative text-black fw-bold mb-10" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-left-arrow lh-1 me-1 position-relative top-2" }, null, -1)
const _hoisted_9 = {
  key: 0,
  class: "text-center"
}
const _hoisted_10 = {
  key: 1,
  class: "text-center text-muted"
}
const _hoisted_11 = {
  key: 2,
  class: "row"
}
const _hoisted_12 = { class: "card h-100 shadow-sm border-0" }
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = { class: "card-title" }
const _hoisted_15 = { class: "mb-1" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("strong", null, "Qualification :", -1)
const _hoisted_17 = { class: "mb-1" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("strong", null, "Expérience :", -1)
const _hoisted_19 = { class: "mb-1" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("strong", null, "Date candidature :", -1)
const _hoisted_21 = { class: "mt-3" }
const _hoisted_22 = {
  key: 0,
  class: "badge bg-info"
}
const _hoisted_23 = ["onClick", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h4", _hoisted_7, " Liste des candidatures pour l’offre : " + _toDisplayString(_ctx.offre?.titre || "..."), 1),
              _createVNode(_component_router_link, {
                to: "/liste-offres",
                class: "btn btn-primary transition border-0 lh-1 fw-medium"
              }, {
                default: _withCtx(() => [
                  _hoisted_8,
                  _createTextVNode(" Retour ")
                ]),
                _: 1
              })
            ]),
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, "Chargement..."))
              : (_ctx.candidaters.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, " Aucune candidature trouvée. "))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.candidaters, (c, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "col-md-4 mb-4"
                      }, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", _hoisted_13, [
                            _createElementVNode("h5", _hoisted_14, _toDisplayString(c.prenom) + " " + _toDisplayString(c.nom), 1),
                            _createVNode(_component_router_link, {
                              class: "btn btn-sm btn-outline-primary",
                              to: { name: 'CandidaterDetailsPage', params: { id: c.id } }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(" Détails ")
                              ]),
                              _: 2
                            }, 1032, ["to"]),
                            _createElementVNode("p", _hoisted_15, [
                              _hoisted_16,
                              _createTextVNode(" " + _toDisplayString(c.qualification || "Non spécifiée"), 1)
                            ]),
                            _createElementVNode("p", _hoisted_17, [
                              _hoisted_18,
                              _createTextVNode(" " + _toDisplayString(c.anneeExperience || 0) + " ans", 1)
                            ]),
                            _createElementVNode("p", _hoisted_19, [
                              _hoisted_20,
                              _createTextVNode(" " + _toDisplayString(_ctx.formatDate(c.dateCandidature)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_21, [
                              (c.estSelectionner)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Sélectionné"))
                                : (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    class: "btn btn-sm btn-outline-success",
                                    onClick: ($event: any) => (_ctx.selectionnerCandidater(c.id)),
                                    disabled: _ctx.selecting
                                  }, " Sélectionner ", 8, _hoisted_23))
                            ])
                          ])
                        ])
                      ]))
                    }), 128))
                  ]))
          ])
        ])
      ])
    ])
  ]))
}